import baseConfig from '@/config/baseConfig.json';
import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';

const home = () => import('../page/home/index.vue');
const searchMerchant = () => import('../page/searchMerchant/index.vue');
const merchantDetail = () => import('../page/merchantDetail/index.vue');
const goodsDetail = () => import('../page/goodsDetail/index.vue');
const searchAddress = () => import('../page/searchAddress/index.vue');
const recommend = () => import('../page/recommend/index.vue');
const evaluate = () => import('../page/evaluateList/index.vue');
const recommendList = () => import('../page/recommend/list/index.vue');
const recommendSuccessful = () => import('../page/recommend/successful/index.vue');
const orderDetail = () => import('../page/orderDetail/index.vue');
const orderConfirm = () => import('../page/orderConfirm/index.vue');
const payResult = () => import('../page/payResult/index.vue');
const checkResult = () => import('../page/checkResult/index.vue');
const rightsDetail = () => import('../page/rightsDetail/index.vue');
const serviceDetail = () => import('../page/serviceDetail/index.vue');
const test1 = () => import('../page/test/index.vue');
const refund = () => import('../page/orderDetail/refundReason.vue');
const cancel = () => import('../page/orderDetail/cancelOrder.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
  },
  {
    path: '/search-merchant',
    name: 'searchMerchant',
    component: searchMerchant,
  },
  {
    path: '/search-address',
    name: 'searchAddress',
    component: searchAddress,
  },
  {
    path: '/merchant-detail',
    name: 'merchantDetail',
    component: merchantDetail,
  },
  {
    path: '/goods-detail',
    name: 'goodsDetail',
    component: goodsDetail,
  },
  {
    path: '/recommend-page',
    name: 'recommend',
    component: recommend,
  },
  {
    path: '/evaluate-list',
    name: 'evaluate',
    component: evaluate,
  },
  {
    path: '/recommend-list',
    name: 'recommendList',
    component: recommendList,
  },
  {
    path: '/recommend-successful',
    name: 'recommendSuccessful',
    component: recommendSuccessful,
  },
  {
    path: '/order-detail',
    name: 'orderDetail',
    component: orderDetail,
  },
  {
    path: '/order-confirm',
    name: 'orderConfirm',
    component: orderConfirm,
  },
  {
    path: '/pay-result',
    name: 'payResult',
    component: payResult,
  },
  {
    path: '/check-result',
    name: 'checkResult',
    component: checkResult,
  },
  {
    path: '/test1',
    name: 'test1',
    component: test1,
  },
  {
    path: '/refund-reason',
    name: 'refund',
    component: refund,
  },
  {
    path: '/cancel-order',
    name: 'cancel',
    component: cancel,
  },
  {
    path: '/rights-detail',
    name: 'rightsDetail',
    component: rightsDetail,
  },
  {
    path: '/service-detail',
    name: 'serviceDetail',
    component: serviceDetail,
  },
];

/** 从 DefinePlugin 读取"模块编码", 本地读到空字符串 */
// eslint-disable-next-line no-undef
const envModuleCode = FX_OFFLINEPKG_MODULE_CODE;
/** FX 在线包基础路径, 结尾是 `/` */
// eslint-disable-next-line no-undef
const envFxBase = FX_BASE;
/** 在线包加上一个部署路径作为 base, 本地开发不使用 base */
const suggestedBase =
  envModuleCode && envFxBase ? `${envFxBase}module_${envModuleCode}/` : undefined;

if (suggestedBase) {
  console.info(`setting router base:`, suggestedBase);
}

if (baseConfig.compatible.isSupportHybrid) {
  routes.forEach(route => {
    route.alias = baseConfig.compatible.prefix + process.env.VUE_APP_OFFLINE_MODULE_CODE + route.path;
    console.log(route.alias);
  });
}

const isOffline = process.env.VUE_APP_OFFLINE === 'true';
const router = createRouter({
  history: isOffline ? createWebHashHistory() : createWebHistory(),
  base: suggestedBase,
  routes, // 使用上方定义的路由配置
});
export default router;
